/*----------------------------------------------------------------------------*\
    FORM.ELEMENTS.input-date
    Date input enhancement, datepicker for browsers who dont support
    it natively
\*----------------------------------------------------------------------------*/

/**
 * Use strict as per:
 * http://ejohn.org/blog/ecmascript-5-strict-mode-json-and-more/
 */
'use strict';


/**
 * Check if oy object exists, otherwise create it
 */
var oy = oy || {};


/**
 * Jshint global references
 * Please define all third party plugins that you use to not break jshinting
 */
/*global Pikaday */
/*global moment */


/*  Component
\*----------------------------------------------------------------------------*/

oy.form.elements.inputDate = {
    init: function(){
        if (oy.cutsMustard) {
            this.initElement(document);
        }
    },

    initElement: function($context, selectCallBack){
        var self = this;
        var $elements = $context.querySelectorAll('.js--input-date');

        for (var i = 0; i < $elements.length; ++i) {
            var $element = $elements[i];
            self.setupElement($element, selectCallBack);
        }
    },

    setupElement: function ($element, selectCallBack) {
        var $input = $element.querySelector('.js--input-date__input');
        var $toggle = $element.querySelector('.js--input-date__toggle');
        $input.classList.add('is-initiated');
        var options = {
            field: $input,
            format: oy.translations.dateFormat,
            i18n: oy.translations.i18n,
            yearRange: 20
        };

        if ($input.getAttribute('data-date-min')) {
            options['minDate'] = moment($input.getAttribute('data-date-min')).toDate();
        }

        if ($input.getAttribute('data-date-max')) {
            options['maxDate'] = moment($input.getAttribute('data-date-max')).toDate();
        }

        if($input.getAttribute('data-date-default')) {
            if($input.getAttribute('data-date-default')!=='') {
                options['defaultDate'] = moment($input.getAttribute('data-date-default')).toDate();
                options['setDefaultDate'] = true;
            }
        }

        if(selectCallBack) {
            options.onSelect =  selectCallBack;
        }

        var picker = new Pikaday(options);

        $toggle.addEventListener('click', function () {
            picker.show();
        });
    }
};


/**
 * Fire ALL the things
 */
window.addEventListener('load', function () {
    oy.form.elements.inputDate.init();
}, false);
